import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AudioSchema, AudioSchemaDeleteRequest } from '../../types/AudioSchemas';
import { deleteAudioSchema } from '../../services/AudioSchemaService';

type Result = UseMutationResult<AudioSchema, Error, AudioSchemaDeleteRequest>;

function useDeleteAudioSchema(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteAudioSchema, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['audio-schemas'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteAudioSchema;
